export const getPrecision = (num: string | undefined) => {
    if (num == null) {
        return 0
    }

    const normalized = num.trim().replace('-', '')
    const dotAt = normalized.indexOf('.')
    return dotAt >= 0 ? normalized.length - dotAt - 1 : 0
}

export const getLotSizeFromPrecision = (num: number | undefined) => {
    if (num == null) {
        return 0
    }

    if (num % 10 !== 0 && num !== 1) {
        return num
    }

    const strNumber = String(num)
    const normalized = strNumber.trim().replace('-', '')
    return normalized.length - 1 > 0 ? normalized.length - 1 : 0
}
